/**
 * 7/18/24 DEPRECATED: Use rems directly
 */
export function getSizing(i: number): string {
  // return i * 8 + "px";
  return i / 2 + "rem";
}
